import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column center>
          <CFView h3 futura bold color="#c60000" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center white bold>
            <CFLink href="https://www.facebook.com/share/1C8o2GR2xD/">
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="The Rice Box Facebook"
              />
            </CFLink>
            <CFLink href="https://www.instagram.com/thericeboxvernon?igsh=YnFndnQ1ZzI0bTh4">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="The Rice Box Facebook"
              />
            </CFLink>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#c60000" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            <CFLink href="https://www.facebook.com/share/1C8o2GR2xD/">
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="The Rice Box Facebook"
                hover
              />
            </CFLink>
            <CFLink href="https://www.instagram.com/thericeboxvernon?igsh=YnFndnQ1ZzI0bTh4">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="The Rice Box Facebook"
                hover
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
